import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import AppBar from '../AppBar';
import Container from '../Container';
import { Divider } from '../Divider';
import LinearProgress from '../LinearProgress';
const useStyles = makeStyles()((theme) => ({
    progressBarColorPrimary: {
        backgroundColor: theme.palette.secondary.main,
    },
    progressColorPrimary: {
        height: 5,
        backgroundColor: theme.palette.grey[300],
    },
}));
const FixedFooter = props => {
    const { classes } = useStyles();
    const { children, appBarProps, dividerTop = false, dividerBottom = false, progressBar = false, progressBarValue = 0, } = props;
    return (_jsxs(React.Fragment, { children: [progressBar && (_jsx(LinearProgress, { "data-test-locator": `Fixed Footer ProgressBar - ${progressBarValue}`, variant: "determinate", classes: {
                    colorPrimary: classes.progressColorPrimary,
                    barColorPrimary: classes.progressBarColorPrimary,
                }, value: progressBarValue })), _jsxs(AppBar, { position: "static", color: "inherit", ...appBarProps, children: [dividerTop && _jsx(Divider, { "data-test-locator": "Fixed Footer Divider Top" }), _jsx(Container, { children: children }), dividerBottom && (_jsx(Divider, { "data-test-locator": "Fixed Footer Divider Bottom" }))] })] }));
};
export { FixedFooter };
